import { LightModeTheme } from "../components/ProfileComponents/Themes";
import { SET_IS_MOBILE, CART_ACTIONS } from "./actionTypes";

const initialMobileState = {
  isMobile: window.innerWidth <= 768, // Initialize based on screen size
};

const initialCartState = {
  cartItems: [], // [{ item, quantity }]
};

export const mobileReducer = (state = initialMobileState, action) => {
  switch (action.type) {
    case SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };

    default:
      return state;
  }
};

export const cartReducer = (state = initialCartState, action) => {
  switch (action.type) {
    case CART_ACTIONS.ADD_TO_CART:
      // If item already in the cart just increase quantity
      const existingItem = state.cartItems.find(
        (item) => item.id === action.payload.id
      );

      if (existingItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((item) =>
            item.id === action.payload.id
              ? { ...item, quantity: item.quantity + action.payload.quantity }
              : item
          ),
        };
      }

      return {
        ...state,
        cartItems: [...state.cartItems, { ...action.payload }],
      };
    case CART_ACTIONS.REMOVE_FROM_CART:
      return {
        ...state,
        cartItems: state.cartItems.filter((item) => item.id !== action.payload),
      };
    case CART_ACTIONS.UPDATE_CART_ITEM:
      // Remove item if quantity is zero
      if (action.payload.quantity <= 0) {
        return {
          ...state,
          cartItems: state.cartItems.filter(
            (item) => item.id !== action.payload.itemId
          ),
        };
      }
      return {
        ...state,
        cartItems: state.cartItems.map((item) =>
          item.id === action.payload.itemId
            ? { ...item, quantity: action.payload.quantity }
            : item
        ),
      };
    case CART_ACTIONS.CLEAR_CART:
      return initialCartState;
    default:
      return state;
  }
};
